/**
 *
 * @module storage
 *
 */

import Logging from './../../../logging/entry';
import CoreStorageProvider from './../shared/coreStorageProvider';
import MemoryStore from './../memoryStore';

/**
 *
 * @class Storage
 * @extends {CoreStorageProvider}
 * @desc ATV Storage provider implementation.
 *
 * @example
 * const storage = new Storage(logger);
 *
 */
export default class Storage extends CoreStorageProvider {

    /**
     *
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(logger = Logging) {

        const scope = global && global.atv;
        const hasLocalStorage = scope && scope.localStorage;
        const storeMessage = hasLocalStorage ? 'Using native localStorage.' : 'Using MemoryStore instance.';

        super(logger);

        /**
         *
         * @access private
         * @type {Object}
         * @desc storage reference, uses the global ATV storage instance,
         * falls back to a plain Object implementation
         *
         */
        this.store = hasLocalStorage ? scope.localStorage : new MemoryStore();

        this.logger.log('Storage', 'Created ATV Provider.');
        this.logger.info('Storage', storeMessage);

    }

}



// WEBPACK FOOTER //
// ./src/services/platforms/apple/storage.js